import React from 'react';
import CIcon from '@coreui/icons-react';
import {cilXCircle} from '@coreui/icons';

const BrokenSensor = (props) => {

  return (    
    <div style={{
      height: 200, 
      padding: 0,
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      color: 'black',
      fontWeight: 600,
    }}>
      <CIcon icon={cilXCircle} size='4xl' style={{color: 'red',}}  />
      <br />
      The {props.sensorName} sensor is currently not reporting data.
    </div>
  );
}

export default BrokenSensor;
